/** The catalog itinerary screen — one vertical list, transparent toolbar fading in on
 *  scroll, sticky bottom bar. No tabs, no bottom sheet, no map. Spec §1D. */
import { useState } from 'react';

import { adaptItinerary } from './adapters/itinerary';
import { BottomBar, Toolbar } from './chrome/Chrome';
import { ItemView, type ItemContext } from './items/Items';
import { ItineraryItemView } from './items/ItineraryItems';
import { mapItineraryDetails } from './mappers/itineraryDetails';
import { imageWidthPx } from '../../deviceProfiles';
import type { ScreenProps } from '../../types';

const SLIDER_HEIGHT = 312;

export function ItineraryScreen({ payload, device, imagesBase }: ScreenProps) {
  const ui = mapItineraryDetails(adaptItinerary(payload), null);
  const [alpha, setAlpha] = useState(0);

  const toolbarHeight = device.statusBarDp + 56;
  const fadeRange = SLIDER_HEIGHT - toolbarHeight;
  const ctx: ItemContext = { imagesBase, imageWidthPx: imageWidthPx(device) };

  return (
    <div style={{ position: 'relative', height: '100%', overflow: 'hidden' }}>
      <Toolbar title={ui.title} statusBarDp={device.statusBarDp} alpha={alpha} />

      <div
        onScroll={(e) => {
          const top = (e.target as HTMLDivElement).scrollTop;
          setAlpha(fadeRange > 0 ? Math.min(1, top / fadeRange) : 1);
        }}
        style={{ height: '100%', overflowY: 'auto', overflowX: 'hidden' }}
      >
        {ui.items.map((item) =>
          item.kind === 'imageSlider' ? (
            <ItemView key={item.key} item={{ ...item, kind: 'imageSlider' }} ctx={ctx} />
          ) : (
            <ItineraryItemView key={item.key} item={item} ctx={ctx} />
          ),
        )}
        <div style={{ height: ui.bottomModel ? 80 + device.navBarDp : device.navBarDp }} />
      </div>

      {ui.bottomModel && (
        <BottomBar
          title={ui.bottomModel.title}
          caption={ui.bottomModel.caption}
          buttonText={ui.bottomModel.buttonText}
          buttonPlacement={ui.bottomModel.buttonPlacement}
          navBarDp={device.navBarDp}
        />
      )}
    </div>
  );
}

export function itineraryScreenNotes(payload: Record<string, unknown>): string[] {
  return mapItineraryDetails(adaptItinerary(payload), null).notes;
}
